import React, { createContext, useState, useEffect, useContext } from "react";
import {
  getProfile,
  getSkills,
  getProjects,
  getResume,
  getBlogs,
} from "../api";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({
    profile: null,
    skills: [],
    projects: [],
    resume: { experience: [], education: [] },
    blogs: [],
    loading: true,
    error: null,
  });

  const fetchData = async () => {
    try {
      const [profileRes, skillsRes, projectsRes, resumeRes, blogsRes] =
        await Promise.all([
          getProfile(),
          getSkills(),
          getProjects(),
          getResume(),
          getBlogs(),
        ]);

      setData({
        profile: profileRes.data,
        skills: skillsRes.data,
        projects: projectsRes.data,
        resume: resumeRes.data,
        blogs: blogsRes.data,
        loading: false,
        error: null,
      });
    } catch (err) {
      console.error("Error fetching data:", err);
      setData((prev) => ({ ...prev, loading: false, error: err.message }));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{ ...data, refresh: fetchData }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
